var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-auto" }, [
    _vm.pltService
      ? _c("div", { staticClass: "d-md-flex d-none justify-content-center" }, [
          _c("div", { staticClass: "brand-section-body-item" }, [
            _c("div", { staticClass: "brand-section-body-item_logo" }, [
              _c("img", {
                staticStyle: { width: "55px", height: "55px" },
                attrs: {
                  src: _vm.platformLogos[_vm.pltService],
                  alt: _vm.pltService + " logo"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "brand-section-body-item_intro" }, [
              _c(
                "span",
                {
                  staticClass: "font-weight-bold",
                  staticStyle: { "font-size": "1.1em" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t(_vm.pltService + "_name")) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t(_vm.pltService + "_slogan")) +
                  "\n      "
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [
          "mt-2 mt-md-auto mx-auto w-100 text-right rtl",
          { "text-right rtl": _vm.$i18n.locale !== "en" }
        ],
        staticStyle: { "max-width": "500px" }
      },
      [
        _c(
          "div",
          {
            staticClass: "mx-auto w-100 border p-3 p-md-4",
            staticStyle: { "max-width": "430px" }
          },
          [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-center align-items-center"
              },
              [
                _vm.pltService && _vm.platformLogos[_vm.pltService]
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "brand-section-body-item_logo d-md-none ml-3",
                        staticStyle: { padding: "5px" }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.platformLogos[_vm.pltService],
                            alt: _vm.pltService + " logo"
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "h1",
                  {
                    staticClass: "mb-4 text-center",
                    staticStyle: { color: "#555", "background-color": "#fff" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "form-header",
                        staticStyle: { "font-size": "55%" }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("login")) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.pltService && _vm.platformLogos[_vm.pltService]
                          ? _c(
                              "span",
                              {
                                staticClass: "d-md-none",
                                staticStyle: { "font-weight": "normal" }
                              },
                              [
                                _vm._v(
                                  "\n              به " +
                                    _vm._s(_vm.$t(_vm.pltService + "_name")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "form",
              {
                ref: "form",
                staticClass: "d-flex justify-content-center flex-column w-100",
                attrs: { method: "POST", action: _vm.urls.login }
              },
              [
                _vm.autoSocialLogin
                  ? _c(
                      "div",
                      {
                        staticClass: "alert alert-success rounded-0",
                        staticStyle: { "margin-bottom": "2rem" }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-info mx-1",
                          staticStyle: { "vertical-align": "middle" }
                        }),
                        _vm._v(" "),
                        _vm.$i18n.locale === "fa"
                          ? _c("span", [
                              _vm._v(
                                "\n            یک حساب کاربری‌ با این ایمیل از قبل موجود است. برای اتصال حساب\n            گوگل‌تان به این حساب، گذرواژه‌تان را وارد کنید\n          "
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n            This email address is already registered. Please enter your\n            password to connect to the associated account.\n          "
                              )
                            ])
                      ]
                    )
                  : [
                      _c(
                        "a",
                        {
                          staticClass: "google_btn mb-1",
                          attrs: {
                            href: _vm.urls.googleLogin,
                            "data-gtm-name": "login_google"
                          }
                        },
                        [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(_vm._s(_vm.$t("google_login")))
                          ]),
                          _vm._v(" "),
                          _vm._m(0)
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "divider mb-1" }, [
                        _c("div", { staticClass: "text text-center" }, [
                          _vm._v(_vm._s(_vm.$t("or")))
                        ])
                      ])
                    ],
                _vm._v(" "),
                _c("field-input", {
                  ref: "email_or_mobile",
                  staticClass: "mb-4",
                  staticStyle: { "margin-bottom": "7px" },
                  attrs: {
                    id: "login_input",
                    type: "text",
                    name: "login",
                    label:
                      _vm.getParam("account_custom_type") !==
                      "yektanet-rubika-adv"
                        ? _vm.$t("email_or_mobile")
                        : _vm.$t("mobile_number"),
                    "server-error": _vm.serverError.login,
                    number: "",
                    rules: [
                      _vm.vRules.required(
                        _vm.$t("validation_message.email_or_mobile_is_required")
                      ),
                      _vm.vRules.email_or_phone()
                    ],
                    "data-gtm-name": "login_email_phone"
                  },
                  model: {
                    value: _vm.emailOrMobile,
                    callback: function($$v) {
                      _vm.emailOrMobile = $$v
                    },
                    expression: "emailOrMobile"
                  }
                }),
                _vm._v(" "),
                _c("field-input", {
                  ref: "password",
                  staticClass: "mb-4",
                  staticStyle: { "margin-bottom": "7px" },
                  attrs: {
                    id: "password_input",
                    type: "password",
                    name: "password",
                    label: _vm.$t("password"),
                    "input-class": "ltr",
                    "server-error": _vm.serverError.password,
                    rules: [
                      _vm.vRules.required(
                        _vm.$t("validation_message.password_is_required")
                      )
                    ],
                    "data-gtm-name": "password"
                  },
                  model: {
                    value: _vm.password,
                    callback: function($$v) {
                      _vm.password = $$v
                    },
                    expression: "password"
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "hidden", name: "csrfmiddlewaretoken" },
                  domProps: { value: _vm.csrfToken }
                }),
                _vm._v(" "),
                _vm.redirectFieldValue
                  ? _c("input", {
                      attrs: { type: "hidden", name: _vm.redirectFieldName },
                      domProps: { value: _vm.redirectFieldValue }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.serverError.nonFieldErrors
                  ? _c(
                      "div",
                      { staticClass: "mt-0 error-text text-center mb-4" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.serverError.nonFieldErrors) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "auth-btn btn btn-primary font-5",
                    staticStyle: { "margin-bottom": "27px" },
                    attrs: { type: "submit", disabled: _vm.isLoading }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.$t("login")) + "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex justify-content-between" }, [
                  _c(
                    "a",
                    {
                      staticClass: "link",
                      attrs: {
                        href: _vm.urls.beginPasswordReset,
                        "data-gtm-name": "login_password_recovery"
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("reset_password")) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "link",
                      attrs: {
                        href: _vm.signupUrl,
                        "data-gtm-name": "login_register"
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("signup")) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ],
              2
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-container" }, [
      _c("span", { staticClass: "icon" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }